export const SOFLINE_API_VOUCHER_SCAN =
  'v1/belege/scan/{{labelType}}/{{data}}';
